var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data_brain_wrap"},[_c('div',{staticClass:"brain_title"},[_vm._v(_vm._s(_vm.oneTitle[0]))]),_vm._m(0),_c('div',{staticClass:"brain_desc",domProps:{"innerHTML":_vm._s(_vm.twoTile[0])}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"braimg"},[_c('img',{staticClass:"hidden-xs-only",attrs:{"src":require("@/assets/img/rectangle.png"),"alt":""}})])
}]

export { render, staticRenderFns }